import axios from 'axios';
import logType from './adminLogType';
import { logTypeExists } from './utilities';
import { elasticRequest } from '../../services/elasticService';

export const addAdminLog = async (
  url: string,
  action: string,
  description: string,
  additionalData: any,
  username: string
) => {
  const typeExists = await logTypeExists(url, 'adminlogs');
  if (!typeExists) {
    addAdminLogType(url);
  }
  const data = {
    action,
    description,
    username,
    additionalData,
    created_date: new Date(),
  };
  url = url + 'adminlogs/default';
  try {
    elasticRequest(url, JSON.stringify(data))
      .then((result) => {
        //console.log('added log type?', JSON.stringify(result));
      })
      .catch(function (error) {
        console.log(error);
      });
  } catch (ex) {
    console.log(ex);
  }
};

export const addAdminLogType = (url: string) => {
  url = url + 'logtype/default';
  try {
    elasticRequest(url, JSON.stringify(logType))
      .then((result) => {
        //console.log('added log type?', JSON.stringify(result));
      })
      .catch(function (error) {
        console.log(error);
      });
  } catch (ex) {
    console.log(ex);
  }
};
